import { faCog } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

import '../../assets/loading.scss'

const Loading = ({ size, style }) => {
  const t = useSelector(selectTranslate)

  return (
    <div className='loading-container' style={style ?? {}}>
      <FontAwesomeIcon icon={faCog} spin size={size} />
      <b>
        {t('Loading ...')}
      </b>
    </div>
  )
}

export default Loading
